import React from "react";

export default function AboutBanner() {
  return (
    <div className="bg-white">
      <div className="px-4 py-8 sm:px-6 sm:py-10 md:px-8 md:py-12 lg:px-10 lg:py-16 w-4/5 mx-auto">
        <div className="relative">
          <div className="flex justify-center">
            <div className="text-center ">
              <h2
                data-aos="fade-up"
                data-aos-delay="100"
                className="text-[#d78558] font-robout text-5xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-[10.8rem] capitalize tracking-[-.04em] leading-tight sm:leading-snug font-bold"
              >
                About us
              </h2>
              <div className="md:text-[1.65rem] text-xl md:leading-10 tracking-tight text-[#1d1d1f] pt-6 sm:pt-8 md:pt-10 lg:pt-12 xl:pt-[4.75rem] font-robout">
                <p data-aos="fade-up" data-aos-delay="200">
                 Citrus Diagnostic Centre, founded by
                  <span className="text-[#d78558] pe-1"> Dr. Kamlesh Amin,</span>
                   {/* and  */}
                  {/* <span className="text-[#d78558] px-1">
                     Dr. Kamlesh Amin 
                  </span> */}
                 is built on the vision of offering patients the most trusted and comprehensive diagnostic care. With years of medical expertise, our team ensures precise reporting, compassionate service, and seamless access for both patients and physicians.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
